import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="p-6 min-w-[320px]">
      <h2 mat-dialog-title class="flex items-center text-red-600 mb-4 text-xl leading-6">
        <mat-icon class="mr-2 text-2xl w-6 h-6">warning</mat-icon>
        {{ data.title }}
      </h2>
      
      <mat-dialog-content class="text-gray-900 text-base leading-relaxed mb-6">
        <p>{{ data.message }}</p>
      </mat-dialog-content>

      <mat-dialog-actions align="end" class="m-0 p-0">
        <button mat-button
                class="flex items-center gap-2 px-4 py-2 font-medium tracking-wide mr-2"
                [mat-dialog-close]="false">
          <mat-icon class="text-lg w-[18px] h-[18px]">close</mat-icon>
          Cancelar
        </button>
        <button mat-raised-button
                class="flex items-center gap-2 px-4 py-2 font-medium tracking-wide"
                color="warn"
                [mat-dialog-close]="true">
          <mat-icon class="text-lg w-[18px] h-[18px]">delete</mat-icon>
          Eliminar
        </button>
      </mat-dialog-actions>
    </div>
  `
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string;
      message: string;
    }
  ) {}
}